import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Ship } from "lucide-react";
import { toast } from "sonner";
import api, { fmtErr } from "../api";
import StatusBadge from "../components/StatusBadge";
import { fmtDate, fmtMoney } from "../utils/format";

const COLUMNS = ["Commandé", "Acheté", "En transit", "Arrivé au port", "En dédouanement"];
const NEXT = { "Commandé": "Acheté", "Acheté": "En transit", "En transit": "Arrivé au port", "Arrivé au port": "En dédouanement", "En dédouanement": "Dédouané" };

export default function Imports() {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const load = () => api.get("/importations").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const advance = async (v) => {
    try {
      await api.patch(`/vehicles/${v.id}`, { status: NEXT[v.status] });
      toast.success(`${v.internal_number} → ${NEXT[v.status]}`);
      load();
    } catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div className="space-y-5" data-testid="imports-page">
      <div>
        <h1 className="font-heading text-2xl font-bold tracking-tight text-slate-900">Importations</h1>
        <p className="mt-1 text-sm text-slate-500">Suivi du pipeline d'importation : commande → achat → transit → port → dédouanement.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 xl:grid-cols-5">
        {COLUMNS.map((col) => (
          <div key={col} className="rounded-xl border border-slate-200 bg-slate-50/60 p-3" data-testid={`import-column-${col.toLowerCase().replace(/[^a-zà-ÿ]/g, "-")}`}>
            <div className="mb-3 flex items-center justify-between px-1">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{col}</p>
              <span className="rounded-full bg-white px-2 py-0.5 text-xs font-bold text-slate-600 border border-slate-200">
                {rows.filter((v) => v.status === col).length}
              </span>
            </div>
            <div className="space-y-3">
              {rows.filter((v) => v.status === col).map((v) => (
                <div key={v.id} className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm" data-testid={`import-card-${v.internal_number}`}>
                  <button onClick={() => navigate(`/vehicules/${v.id}`)} className="w-full text-left">
                    <p className="font-semibold text-slate-800">{v.brand} {v.model}</p>
                    <p className="font-mono-num text-xs text-slate-400">{v.internal_number}</p>
                    <p className="mt-1 text-xs text-slate-500">{v.origin_country || "?"} → {v.arrival_port || "?"}</p>
                    <p className="mt-1 font-mono-num text-xs font-semibold text-slate-700">{fmtMoney(v.cost_basis)}</p>
                    <p className="mt-1 text-[11px] text-amber-600">{v.days_in_status} j dans cette étape</p>
                  </button>
                  <button onClick={() => advance(v)}
                    className="mt-2 flex w-full items-center justify-center gap-1 rounded-md bg-blue-50 px-2 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-100 transition-colors"
                    data-testid={`advance-${v.internal_number}`}>
                    {NEXT[col]} <ArrowRight className="h-3 w-3" />
                  </button>
                </div>
              ))}
              {rows.filter((v) => v.status === col).length === 0 && (
                <div className="rounded-lg border border-dashed border-slate-200 py-6 text-center">
                  <Ship className="mx-auto h-5 w-5 text-slate-300" />
                  <p className="mt-1 text-xs text-slate-400">Vide</p>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
